import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { PeremriLloji, PeremrillojiParametri } from '@core/enums/peremri/peremri.enum';
import { PeremriBazaForCreationDTO } from '@core/interfaces/dto/peremri-baza-for-creation-dto.interface';
import { PeremriBazaForUpdateDTO } from '@core/interfaces/dto/peremri-baza-for-update-dto.interface';
import { PeremriForCreationDTO } from '@core/interfaces/dto/peremri-for-creation-dto.interface';
import { PeremriTrajtatEShkurtraTeBashkuaraForCreationDTO } from '@core/interfaces/dto/peremri-trajtat-e-shkurtra-te-bashkuara-for-creation-dto.interface';
import { PeremriBaza } from '@core/interfaces/models/peremri-baza.interface';
import { PeremriBazaService } from './peremri-baza.service';
import { PeremriDeftorService } from './peremri-deftor/peremri-deftor.service';
import { PeremriIPacaktuarService } from './peremri-i-pacaktuar-service/peremri-i-pacaktuar.service';
import { PeremriLidhorService } from './peremri-lidhor-service/peremri-lidhor.service';
import { PeremriPronorService } from './peremri-pronor/peremri-pronor.service';
import { PeremriPyetesService } from './peremri-pyetes-service/peremri-pyetes.service';
import { PeremriVetorTrajtatEBashkuaraService } from './peremri-vetor-service/peremri-vetor-trajtat-e-bashkuara.service';
import { PeremriVetorService } from './peremri-vetor-service/peremri-vetor.service';
import { PeremriVetvetorService } from './peremri-vetvetor-service/peremri-vetvetor.service';

@Injectable({
  providedIn: 'root'
})
export class PeremriEditorService {

  constructor(
    private peremriBazaService: PeremriBazaService,
    private fb: UntypedFormBuilder,
    private peremriVetvetorService: PeremriVetvetorService,
    private peremriVetorService: PeremriVetorService,
    private peremriVetorTrajtatEShkurtraTeBashkuara: PeremriVetorTrajtatEBashkuaraService,
    private peremriIPacaktuarService: PeremriIPacaktuarService,
    private peremeriLidhorService: PeremriLidhorService,
    private peremriPyetesService: PeremriPyetesService,
    private peremriDeftorService: PeremriDeftorService,
    private peremriPronorService: PeremriPronorService,
  ) { }

  getPeremriBazaForm(form: UntypedFormGroup, manual: boolean) {
    if (form.get('peremriBaza')) {
      return <UntypedFormGroup>form.get('peremriBaza');
    }

    form.addControl(
      'peremriBaza',
      this.fb.group({
        id: null,
        bazaId: null,
        gjiniaId: null,
        renditjaId: null,
        trajtaId: null,
        vetaId: null,
        llojiId: null,
        parametriId: null,
        numriId: null,
        rasaId: null,
        formaFjalesId: null,
        radhitja: null,
        peremri: this.fb.array([]),
        mashkulloreParam: false,
        femeroreParam: false,
        peremriVetor: this.fb.array([]),
        peremriVetorTrajtatEShkurtra: this.fb.array([]),
        peremriVetorTrajtatEShkurtraTeBashkuara: this.fb.array([]),
        peremriVetvetor: this.fb.array([]),
        peremriDeftor: this.fb.array([]),
        peremriPronor: this.fb.array([]),
        peremriPyetes: this.fb.array([]),
        peremriLidhor: this.fb.array([]),
        peremriIPacaktuar: this.fb.array([]),
        // inputiManual: new FormControl(null),
      })
    );

    this.peremriVetorService.generateForms(form, manual);
    this.peremriVetorTrajtatEShkurtraTeBashkuara.generateForms(form, manual);
    this.peremriVetvetorService.generateForms(form, manual);
    this.peremriIPacaktuarService.generateForms(form, manual);
    this.peremeriLidhorService.generateForms(form, manual);
    this.peremriPyetesService.generateForms(form, manual);
    this.peremriDeftorService.generateForms(form, manual);
    this.peremriPronorService.generateForms(form, manual);

    return form.get('peremriBaza') as UntypedFormGroup;
  }

  generatePeremriVetorFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    this.peremriVetorService.generateFormula(peremriLlojiParametri, form);
  }

  generatePeremriVetvetorFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    this.peremriVetvetorService.generateFormula(peremriLlojiParametri, form);
  }

  generatePeremriVetorTrajtatEShkurtraTeBashkuaraFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    this.peremriVetorTrajtatEShkurtraTeBashkuara.generateTrajtatEShkurtraTeBashkuaraFormula(peremriLlojiParametri, form);
  }

  generatePeremriIPacaktuarFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    this.peremriIPacaktuarService.generateFormula(peremriLlojiParametri, form);
  }

  generatePeremriLidhorFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    this.peremeriLidhorService.generateFormula(peremriLlojiParametri, form)
  }

  generatePeremriPyetesFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    this.peremriPyetesService.generateFormula(peremriLlojiParametri, form);
  }

  generatePeremriDeftorFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    this.peremriDeftorService.generateFormula(peremriLlojiParametri, form);
  }

  generatePeremriPronorFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    this.peremriPronorService.generateFormula(peremriLlojiParametri, form);
  }

  insertPeremriBazaIntoEditor(peremriBaza: PeremriBaza, form: UntypedFormGroup, manual: boolean) {

    this.resetPeremriBaza(form, manual);

    this.getPeremriBazaForm(form, manual).patchValue({
      id: peremriBaza.id,
      bazaId: peremriBaza.bazaId,
      llojiId: peremriBaza.llojiId,
      parametriId: peremriBaza.nenllojiId,
      fjala: peremriBaza.fjala
    })

    this.peremriVetvetorService.insertForms(peremriBaza, form, manual);
    this.peremriVetorService.insertForms(peremriBaza, form, manual);
    this.peremriVetorTrajtatEShkurtraTeBashkuara.insertForms(peremriBaza, form, manual);
    this.peremriIPacaktuarService.insertForms(peremriBaza, form, manual);
    this.peremeriLidhorService.insertForms(peremriBaza, form, manual);
    this.peremriPyetesService.insertForms(peremriBaza, form, manual);
    this.peremriDeftorService.insertForms(peremriBaza, form, manual);
    this.peremriPronorService.insertForms(peremriBaza, form, manual);
  }


  getPeremriBazaDTO(form: UntypedFormGroup, manual: boolean) {
    const pb = this.getPeremriBazaForm(form, manual).getRawValue();

    let peremriForCreationDTO: PeremriForCreationDTO[] = [];
    switch (pb.llojiId) {
      //vetor
      case 10:
        peremriForCreationDTO = this.peremriVetorService.getCreationDTO(form);
        break;
      //vetvetor
      case 11:
        peremriForCreationDTO = this.peremriVetvetorService.getCreationDTO(form);
        break;
      //deftore
      case 12:
        peremriForCreationDTO = this.peremriDeftorService.getCreationDTO(form);
        break;
      //pronor
      case 13:
        peremriForCreationDTO = this.peremriPronorService.getCreationDTO(form);
        break;
      //pyetes
      case 14:
        peremriForCreationDTO = this.peremriPyetesService.getCreationDTO(form);
        break;
      //lidhor
      case 15:
        peremriForCreationDTO = this.peremeriLidhorService.getCreationDTO(form);
        break;
      //i pacaktuar
      case 16:
        peremriForCreationDTO = this.peremriIPacaktuarService.getCreationDTO(form);
        break;
      default:
        break;
    }

    const peremriTrajtatEShkurtraTeBashkuaraForCreationDTO: PeremriTrajtatEShkurtraTeBashkuaraForCreationDTO[] =
      this.peremriVetorTrajtatEShkurtraTeBashkuara.getCreationDTO(form);


    if (pb.id) {
      const peremriBazaForUpdateDTO: PeremriBazaForUpdateDTO = {
        id: pb.id,
        llojiId: pb.llojiId,
        nenllojiId: pb.parametriId,
        trajteEShkurterEBashkuar: pb.llojiId == PeremriLloji.Vetor,
        peremriForCreationDTO: peremriForCreationDTO,
        peremriTrajtatEShkurtraTeBashkuaraForCreationDTO: pb.llojiId == PeremriLloji.Vetor ? peremriTrajtatEShkurtraTeBashkuaraForCreationDTO : [],
      };
      return peremriBazaForUpdateDTO;
    }
    else {
      const peremriBazaForCreationDTO: PeremriBazaForCreationDTO = {
        id: pb.id,
        bazaId: pb.bazaId,
        llojiId: pb.llojiId,
        nenllojiId: pb.parametriId,
        trajteEShkurterEBashkuar: pb.llojiId == 10,
        peremriForCreationDTO: peremriForCreationDTO,
        peremriTrajtatEShkurtraTeBashkuaraForCreationDTO: pb.llojiId == PeremriLloji.Vetor ? peremriTrajtatEShkurtraTeBashkuaraForCreationDTO : [],
      };
      return peremriBazaForCreationDTO;
    }
  }

  private resetPeremriBaza(form: UntypedFormGroup, manual: boolean) {
    this.getPeremriBazaForm(form, manual).reset({
      id: null,
      bazaId: null,
      gjiniaId: null,
      renditjaId: null,
      trajtaId: null,
      vetaId: null,
      llojiId: null,
      parametriId: null,
      numriId: null,
      rasaId: null,
      formaFjalesId: null,
      radhitja: null
    });

    Object.keys(this.getPeremriBazaForm(form, manual).controls)
      .filter((c) => c.startsWith('peremri'))
      .flatMap((field) => {
        return form.get('peremriBaza')?.get(field) as UntypedFormArray;
      })
      .forEach((formArray) => {
        while (formArray.controls.length > 0) {
          formArray.removeAt(0);
        }
      });
  }
}
